import { defineMessage } from 'react-intl';

export const customerRatingsResponseMessage = defineMessage({
  id: 'customerRatings.response.card.title',
  defaultMessage: 'Antwort von BAUR',
});
